import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import Creatable from "react-select/creatable";

import TextEditor from "./TextEditor";
import GetTimeOptions from "../GetTimeOptions";
import GetDurationOptions from "../GetDurationOptions";
import SelectTask from "../SelectTask";
import "../trigger-settings.css";

import {
  setRequiredError,
  setTriggerAction,
  setTriggerActionValue,
} from "../../actions/triggerAction";
import {
  ACTION_CONTACT_UPDATE_DEFINED_FILTER,
  ACTION_CONTACT_UPDATE_FILTER_OPTIONS,
  ACTION_TYPES,
  AGENCY_BUSINESS_TYPE,
  PACKAGE_PAGE_URL,
  PERMISSION_LEVELS,
  PERMISSION_MODULES,
  PRIVACY_LEVEL,
  TRIGGER_TYPES,
} from "../../../../helpers/CoreConstant";
import {
  Button,
  FormControl,
  MenuItem,
  Select as MaterialSelect,
  FormGroup,
  InputLabel,
  TextField,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import { iconList } from "../../IconList";
import BootstrapTooltip from "../../../globals/BootstrapTooltip";
import Utils from "../../../addContact/Utils";
import { getCollaboratorDropdownList } from "../../../../api/triggerApi";
import SmartWebhookDrawer from "./smartWebhookBuilder/SmartWebhookDrawer";
import { getCookie } from "../../../addContact/Cookie";

export const sendWebhookTest = (method = "POST", url, postData) =>
  fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + getCookie(process.env.REACT_APP_ACCESS_TOKEN),
    },
    referrerPolicy: "origin",
    body: JSON.stringify(postData),
  })
    .then((res) => res.json())
    .catch(() => false);

const customPersonalizedStyle = {
  container: () => ({ marginLeft: 15, position: "relative" }),
  input: () => ({ height: 40 }),
  menu: () => ({
    top: "auto",
    position: "absolute",
    zIndex: 99999,
    background: "#fff",
    width: "100%",
  }),
};
const customEmailPersonalizedStyle = { input: () => ({ height: 40 }) };
const customMessagePersonalizedStyle = {
  input: () => ({ height: 40 }),
  container: () => ({ width: 200, position: "relative" }),
};

const mapStateToProps = (state) => ({
  loading: state.triggerSettingReducer.loading,
  triggerRule: state.triggerSettingReducer.triggerRule,
  allActionItem: state.triggerSettingReducer.allActionItem,
  allCampaign: state.triggerSettingReducer.allCampaign,
  allTag: state.triggerSettingReducer.allTag,
  allPipeline: state.triggerSettingReducer.allPipeline,
  allStage: state.triggerSettingReducer.allStage,
  allVirtualNumber: state.triggerSettingReducer.allVirtualNumber,
  allEmail: state.triggerSettingReducer.allEmail,
  allList: state.triggerSettingReducer.allList,
  profile: state.triggerSettingReducer.profile,
  agency: state.triggerSettingReducer.agency,
  allCollaborator: state.triggerSettingReducer.allCollaborator,
  data: state.triggerSettingReducer.data,
  email_templates: state.triggerSettingReducer.email_templates,
  allIntegrations: state.triggerSettingReducer.allIntegrations,
  triggerActionValue: state.triggerSettingReducer.triggerActionValue,
  allSources: state.triggerSettingReducer.allSources,
  triggerItemId: state.triggerSettingReducer.triggerItemId,
});

function mapDispatchToProps(dispatch) {
  return {
    setTriggerAction: (id) => dispatch(setTriggerAction(id)),
    setTriggerActionValue: (param) => dispatch(setTriggerActionValue(param)),
    setRequiredError: (param) => dispatch(setRequiredError(param)),
  };
}

const SingleAction = (props) => {
  const isAgencyTypeInsurance =
    Utils.getAccountData("agencyBusinessType") ===
    AGENCY_BUSINESS_TYPE.INSURANCE;
  const canUserManageGlobalItem = window.hasPermission(
    PERMISSION_MODULES.MANAGE_GLOBAL_ITEMS,
    PERMISSION_LEVELS.WRITE
  );
  const isTriggerPrivate =
    props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_PRIVATE;
  const isUserTriggerOwner =
    props.triggerRule.user_id === Utils.getAccountData("userId");
  const hasPermission = isAgencyTypeInsurance
    ? (!isTriggerPrivate && canUserManageGlobalItem) ||
      (isTriggerPrivate && isUserTriggerOwner)
    : true;

  const [state, setState] = useState({
    show: false,
    selected_action_id: 0,
    selected_action: {},
    selected_action_values: {},
    selected_campaign_to_take_action: null,
    selected_tag_to_take_action: null,
    selected_list_to_take_action: null,
    selected_collaborator_to_take_action: null,
    selected_pipeline_to_take_action: null,
    selected_stage_to_take_action: null,
    selected_contact_update_define_filters: null,
    selected_contact_update_take_action: null,
    defaultCampaignOptions: [],
    defaultTagOptions: [],
    defaultListOptions: [],
    defaultCollaboratorOptions: [],
    templateCollaboratorList: [],
    defaultPipelineOptions: [],
    defaultStageOptions: [],
    deal_value: 0,
    deal_closing_day: 0,
    createOrMove: 0,
    deleteType: 1,
    sms: "",
    mySmsCount: 0,
    fromNumber: null,
    to_sms_type: 0,
    to_sms: null,
    note: "",
    from_email: null,
    to_email_type: 0,
    to_email: null,
    email_subject: "",
    email_body: "",
    textEditor: "",
    webhook_url: "",
    zapier_webhook_url: "",
    title: "",
    task_description: "",
    time: "12:00 PM",
    duration: "00:15",
    taskTitle: "call",
    task_id: 1,
    assign_to: null,
    day: 1,
    integration_id: null,
    defaultSourceOptions: [],
    selected_source_to_take_action: null,
    twilio_sms_send_user: "",
    twilio_email_send_user: "",
    selectedSmartWebhook: null,
    isSubmittingAddSmartWebhookForm: false,
    openSmartWebhookBuilder: false,
    smart_webhook_data: null,
  });

  useEffect(() => {
    if (props.actionValue) loadData(props.actionValue, "did");
    if (props.newAction) setState((s) => ({ ...s, selected_action_id: 0 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.selectedActionValue) {
      loadData(props.selectedActionValue, "update");
    } else {
      setState({
        show: false,
        selected_action_id: 0,
        selected_action: {},
        selected_action_values: {},
        selected_campaign_to_take_action: null,
        selected_tag_to_take_action: null,
        selected_list_to_take_action: null,
        selected_collaborator_to_take_action: null,
        selected_pipeline_to_take_action: null,
        selected_stage_to_take_action: null,
        selected_contact_update_define_filters: null,
        selected_contact_update_take_action: null,
        defaultCampaignOptions: [],
        defaultTagOptions: [],
        defaultListOptions: [],
        defaultCollaboratorOptions: [],
        templateCollaboratorList: [],
        defaultPipelineOptions: [],
        defaultStageOptions: [],
        deal_value: 0,
        deal_closing_day: 0,
        createOrMove: 0,
        deleteType: 1,
        sms: "",
        mySmsCount: 0,
        fromNumber: null,
        to_sms_type: 0,
        to_sms: null,
        note: "",
        from_email: null,
        to_email_type: 0,
        to_email: null,
        email_subject: "",
        email_body: "",
        textEditor: "",
        webhook_url: "",
        zapier_webhook_url: "",
        title: "",
        task_description: "",
        time: "12:00 PM",
        duration: "00:15",
        taskTitle: "call",
        task_id: 1,
        assign_to: null,
        day: 1,
        integration_id: null,
        defaultSourceOptions: [],
        selected_source_to_take_action: null,
        twilio_sms_send_user: "",
        twilio_email_send_user: "",
        selectedSmartWebhook: null,
        isSubmittingAddSmartWebhookForm: false,
        openSmartWebhookBuilder: false,
        smart_webhook_data: null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedActionValue]);

  const textEditorRef = useRef(null);

  const getActionById = (id, list) => list.filter((action) => action.id === id);

  const loadData = (actionValue, from) => {
    let trigger_action_id = "",
      trigger_action_value = "";
    if (from === "did" && actionValue) {
      trigger_action_id = actionValue.user_trigger_action_item_id;
      trigger_action_value = actionValue.user_trigger_action_item_value;
      const [act] = getActionById(trigger_action_id, props.allActionItem);
      changeValue(trigger_action_id, act);
    } else if (from === "update") {
      trigger_action_id = actionValue.action_id;
      trigger_action_value = actionValue;
      const [act] = getActionById(trigger_action_id, props.allActionItem);
      setState((s) => ({
        ...s,
        selected_action_id: trigger_action_id,
        selected_action: act,
      }));
    }

    // now mirror every branch that sets “selected_…_to_take_action”
    if (
      [
        ACTION_TYPES.ADD_TO_CAMPAIGN,
        ACTION_TYPES.REMOVE_FROM_SINGLE_CAMPAIGN,
      ].includes(trigger_action_id)
    ) {
      const [camp] = getActionById(
        trigger_action_value.campaign_id,
        props.allCampaign
      );
      if (camp)
        setState((s) => ({
          ...s,
          selected_campaign_to_take_action: {
            label: camp.title,
            value: trigger_action_value.campaign_id,
          },
        }));
    }

    if (
      [ACTION_TYPES.ADD_TAG, ACTION_TYPES.REMOVE_TAG].includes(
        trigger_action_id
      )
    ) {
      const [tag] = getActionById(trigger_action_value.tag_id, props.allTag);
      if (tag)
        setState((s) => ({
          ...s,
          selected_tag_to_take_action: {
            label: tag.name,
            value: trigger_action_value.tag_id,
          },
        }));
    }

    if (
      [ACTION_TYPES.ADD_LIST, ACTION_TYPES.REMOVE_LIST].includes(
        trigger_action_id
      )
    ) {
      const [lst] = getActionById(trigger_action_value.list_id, props.allList);
      if (lst)
        setState((s) => ({
          ...s,
          selected_list_to_take_action: {
            label: lst.title,
            value: trigger_action_value.list_id,
          },
        }));
    }

    if (
      [
        ACTION_TYPES.ADD_COLLABORATOR,
        ACTION_TYPES.REMOVE_COLLABORATOR,
      ].includes(trigger_action_id)
    ) {
      const [coll] = getActionById(
        trigger_action_value.collaborator_id,
        props.allCollaborator
      );
      if (coll)
        setState((s) => ({
          ...s,
          selected_collaborator_to_take_action: {
            label: coll.full_name,
            value: trigger_action_value.collaborator_id,
          },
        }));
    }

    if (trigger_action_id === ACTION_TYPES.CHANGE_STAGE) {
      // pipeline & stage set + deal_value etc
      const [pl] = getActionById(
        trigger_action_value.pipeline_id,
        props.allPipeline
      );
      const [st] = getActionById(trigger_action_value.stage_id, props.allStage);
      getDefaultOptionForPipeline();
      if (pl)
        setState((s) => ({
          ...s,
          selected_pipeline_to_take_action: {
            label: pl.title,
            value: trigger_action_value.pipeline_id,
          },
          deal_value: trigger_action_value.deal_value,
          createOrMove: trigger_action_value.createOrMove,
          deal_closing_day: trigger_action_value.deal_closing_day,
        }));
      if (st)
        setState((s) => ({
          ...s,
          selected_stage_to_take_action: {
            label: st.stage,
            value: trigger_action_value.stage_id,
          },
        }));
      getDefaultOptionForStage(trigger_action_value.pipeline_id);
    }

    if (trigger_action_id === ACTION_TYPES.REMOVE_DEAL) {
      const [pl] = getActionById(
        trigger_action_value.pipeline_id,
        props.allPipeline
      );
      const [st] = getActionById(trigger_action_value.stage_id, props.allStage);
      getDefaultOptionForPipeline();
      if (pl)
        setState((s) => ({
          ...s,
          selected_pipeline_to_take_action: {
            label: pl.title,
            value: trigger_action_value.pipeline_id,
          },
        }));
      setState((s) => ({ ...s, deleteType: trigger_action_value.deleteType }));
      if (st)
        setState((s) => ({
          ...s,
          selected_stage_to_take_action: {
            label: st.stage,
            value: trigger_action_value.stage_id,
          },
        }));
      getDefaultOptionForStage(trigger_action_value.pipeline_id);
    }

    if (trigger_action_id === ACTION_TYPES.SEND_SMS) {
      setState((s) => ({
        ...s,
        fromNumber: {
          label: trigger_action_value.from,
          value: trigger_action_value.from,
        },
        sms: trigger_action_value.sms,
        to_sms_type: trigger_action_value.to_type ?? 0,
        to_sms: trigger_action_value.to ?? null,
        mySmsCount: trigger_action_value.mySmsCount,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.SEND_EMAIL) {
      setState((s) => ({
        ...s,
        from_email: {
          label: trigger_action_value.from,
          value: trigger_action_value.from,
        },
        to_email_type: trigger_action_value.to_type ?? 0,
        to_email: trigger_action_value.to ?? null,
        email_subject: trigger_action_value.email_subject,
        email_body: trigger_action_value.email_body,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.ADD_NOTE) {
      setState((s) => ({ ...s, note: trigger_action_value.note }));
    }

    if (trigger_action_id === ACTION_TYPES.WEBHOOK_URL) {
      setState((s) => ({
        ...s,
        webhook_url: trigger_action_value.webhook_url,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.ZAPIER_WEBHOOK) {
      setState((s) => ({
        ...s,
        zapier_webhook_url: trigger_action_value.zapier_webhook_url,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.ADD_TASK) {
      setState((s) => ({
        ...s,
        title: trigger_action_value.title,
        task_description: trigger_action_value.task_description,
        time: trigger_action_value.time,
        duration: trigger_action_value.duration,
        day: trigger_action_value.day,
        assign_to: trigger_action_value.assign_to ?? null,
        task_id: trigger_action_value.task_type,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.THIRD_PARTY_INTEGRATION) {
      setState((s) => ({
        ...s,
        integration_id: trigger_action_value.integration_id,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.ADD_SOURCE) {
      const [src] = getActionById(
        trigger_action_value.source_id,
        props.allSources
      );
      if (src)
        setState((s) => ({
          ...s,
          selected_source_to_take_action: {
            label: src.source_title,
            value: src.id,
          },
        }));
    }

    if (trigger_action_id === ACTION_TYPES.TWILIO_EMAIL_USER) {
      setState((s) => ({
        ...s,
        twilio_email_send_user: trigger_action_value?.value,
        email_subject: trigger_action_value?.subject,
        email_body: trigger_action_value?.message,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.TWILIO_SMS_USER) {
      setState((s) => ({
        ...s,
        twilio_sms_send_user: trigger_action_value?.value,
        sms: trigger_action_value?.message,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.SMART_WEBHOOK) {
      setState((s) => ({
        ...s,
        smart_webhook_data: trigger_action_value.smart_webhook_data,
      }));
    }

    if (trigger_action_id === ACTION_TYPES.UPDATE_CONTACT) {
      const df = ACTION_CONTACT_UPDATE_DEFINED_FILTER.find(
        (a) => a.value === trigger_action_value.defined_filter
      );
      const sel = ACTION_CONTACT_UPDATE_FILTER_OPTIONS.find(
        (a) => a.value === trigger_action_value.selected_data
      );
      if (df)
        setState((s) => ({
          ...s,
          selected_contact_update_define_filters: df,
          selected_contact_update_take_action: sel || null,
        }));
    }
  };

  const changeValue = (id, action) => {
    if (id !== state.selected_action_id) {

      if (id === ACTION_TYPES.THIRD_PARTY_INTEGRATION) {
        props.setTriggerActionValue({
          data: {
            id: state.actionValue ? state.actionValue.id : "",
            action_id: id,
            integration_id: parseInt(null, 10)
          },
          index: props.RowIndex
        });
      }

      setState((s) => {
        const newState = {
          ...s,
          selected_action_id: id,
          selected_action: action,
          selected_campaign_to_take_action: null,
          selected_tag_to_take_action: null,
          selected_list_to_take_action: null,
          selected_list_option: null,
          selected_collaborator_to_take_action: null,
          selected_pipeline_to_take_action: null,
          selected_stage_to_take_action: null,
          selected_contact_update_define_filters: null,
          selected_contact_update_take_action: null,
          defaultCampaignOptions: [],
          defaultTagOptions: [],
          defaultListOptions: [],
          defaultCollaboratorOptions: [],
          templateCollaboratorList: [],
          defaultPipelineOptions: [],
          defaultStageOptions: [],
          deal_value: 0,
          deal_closing_day: 0,
          createOrMove: 0,
          deleteType: 1,
          sms: "",
          mySmsCount: 0,
          fromNumber: null,
          to_sms_type: 0,
          to_sms: null,
          note: "",
          from_email: null,
          to_email_type: 0,
          to_email: null,
          email_subject: "",
          email_body: "",
          textEditor: "",
          webhook_url: "",
          zapier_webhook_url: "",
          title: "",
          task_description: "",
          time: "12:00 PM",
          duration: "00:15",
          taskTitle: "call",
          task_id: 1,
          assign_to: null,
          day: 1,
          integration_id: null,
          defaultSourceOptions: [],
          selected_source_to_take_action: null,
          twilio_sms_send_user: "",
          twilio_email_send_user: "",
          selectedSmartWebhook: null,
          isSubmittingAddSmartWebhookForm: false,
          openSmartWebhookBuilder: false,
          smart_webhook_data: null,
        };
        // Dispatch for actions that don't require additional input
        if (
          [
            ACTION_TYPES.REMOVE_FROM_ALL_CAMPAIGN,
            ACTION_TYPES.REMOVE_ALL_TAG,
            ACTION_TYPES.TWILIO_PAUSE_ALL_CAMPAIGN,
            ACTION_TYPES.TWILIO_PAUSE_ALL_COMMUNICATION,
          ].includes(id)
        ) {
          publishActionValueWithState(newState);
        }
        return newState;
      });
      props.setTriggerAction(id);

      // Fetch defaults for specific actions
      if (
        [
          ACTION_TYPES.ADD_TO_CAMPAIGN,
          ACTION_TYPES.REMOVE_FROM_SINGLE_CAMPAIGN,
        ].includes(id)
      ) {
        getDefaultOptionForCampaign();
      } else if ([ACTION_TYPES.ADD_TAG, ACTION_TYPES.REMOVE_TAG].includes(id)) {
        getDefaultOptionForTag();
      } else if (
        [ACTION_TYPES.ADD_LIST, ACTION_TYPES.REMOVE_LIST].includes(id)
      ) {
        getDefaultOptionForList();
      } else if (
        [
          ACTION_TYPES.ADD_COLLABORATOR,
          ACTION_TYPES.REMOVE_COLLABORATOR,
        ].includes(id)
      ) {
        getDefaultOptionForCollaborator();
        getTemplateCollaboratorList();
      } else if (
        id === ACTION_TYPES.CHANGE_STAGE ||
        +id === ACTION_TYPES.REMOVE_DEAL
      ) {
        getDefaultOptionForPipeline();
      } else if (id === ACTION_TYPES.SEND_SMS) {
        setState((s) => ({ ...s, fromNumber: props.allVirtualNumber[0] }));
      } else if (id === ACTION_TYPES.SEND_EMAIL) {
        if (
          props.agency.email_provider !== 0 &&
          props.profile.email_provider === 1
        ) {
          const info = JSON.parse(props.profile.nylas_email_provider_info);
          setState((s) => ({
            ...s,
            from_email: { label: info.email, value: info.email },
          }));
        } else {
          setState((s) => ({ ...s, from_email: props.allEmail[0] }));
        }
      } else if (id === ACTION_TYPES.ADD_SOURCE) {
        getDefaultOptionForSource();
      }
    }
    hide();
  };

  const publishActionValueWithState = (updatedState) => {
    const { selected_action_id } = updatedState;
    const { RowIndex, actionValue } = props;

    const base = { id: actionValue ? actionValue.id : "" };

    switch (selected_action_id) {
      case ACTION_TYPES.ADD_TO_CAMPAIGN:
      case ACTION_TYPES.REMOVE_FROM_SINGLE_CAMPAIGN:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            campaign_id:
              updatedState.selected_campaign_to_take_action?.value ?? null,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.REMOVE_FROM_ALL_CAMPAIGN:
      case ACTION_TYPES.REMOVE_ALL_TAG:
      case ACTION_TYPES.TWILIO_PAUSE_ALL_CAMPAIGN:
      case ACTION_TYPES.TWILIO_PAUSE_ALL_COMMUNICATION:
        props.setTriggerActionValue({
          data: { ...base, action_id: selected_action_id },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.ADD_TAG:
      case ACTION_TYPES.REMOVE_TAG:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            tag_id: updatedState.selected_tag_to_take_action?.value ?? null,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.ADD_LIST:
      case ACTION_TYPES.REMOVE_LIST:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            list_id: updatedState.selected_list_to_take_action?.value ?? null,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.ADD_COLLABORATOR:
      case ACTION_TYPES.REMOVE_COLLABORATOR:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            collaborator_id:
              updatedState.selected_collaborator_to_take_action?.value ?? null,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.CHANGE_STAGE:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            createOrMove: parseInt(updatedState.createOrMove, 10),
            pipeline_id:
              updatedState.selected_pipeline_to_take_action?.value ?? null,
            stage_id: updatedState.selected_stage_to_take_action?.value ?? null,
            deal_value: parseInt(updatedState.deal_value, 10),
            deal_closing_day: parseInt(updatedState.deal_closing_day, 10),
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.REMOVE_DEAL: {
        let pipeline_id =
          updatedState.selected_pipeline_to_take_action?.value ?? null;
        let stage_id =
          updatedState.selected_stage_to_take_action?.value ?? null;
        if (updatedState.deleteType === 2) {
          pipeline_id = null;
          stage_id = null;
        }
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            deleteType: parseInt(updatedState.deleteType, 10),
            pipeline_id,
            stage_id,
          },
          index: RowIndex,
        });
        break;
      }

      case ACTION_TYPES.SEND_SMS:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            from: updatedState.fromNumber?.value ?? null,
            sms: updatedState.sms,
            to_type: parseInt(updatedState.to_sms_type, 10),
            to: updatedState.to_sms,
            mySmsCount: updatedState.mySmsCount,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.SEND_EMAIL:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            from: updatedState.from_email?.value,
            to_type: parseInt(updatedState.to_email_type, 10),
            to: updatedState.to_email,
            email_subject: updatedState.email_subject,
            email_body: updatedState.email_body,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.ADD_NOTE:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            note: updatedState.note,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.WEBHOOK_URL:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            webhook_url: updatedState.webhook_url,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.SMART_WEBHOOK:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            smart_webhook_data: updatedState.smart_webhook_data,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.ZAPIER_WEBHOOK:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            zapier_webhook_url: updatedState.zapier_webhook_url,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.ADD_TASK:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            title: updatedState.title,
            assign_to: parseInt(updatedState.assign_to, 10),
            task_description: updatedState.task_description,
            day: parseInt(updatedState.day, 10),
            time: updatedState.time,
            duration: updatedState.duration,
            task_type: updatedState.task_id,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.THIRD_PARTY_INTEGRATION:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            integration_id: updatedState.integration_id,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.ADD_SOURCE:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            source_id:
              updatedState.selected_source_to_take_action?.value ?? null,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.TWILIO_SMS_USER:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            value: updatedState.twilio_sms_send_user,
            message: updatedState.sms,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.TWILIO_EMAIL_USER:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            value: updatedState.twilio_email_send_user,
            subject: updatedState.email_subject,
            message: updatedState.email_body,
          },
          index: RowIndex,
        });
        break;

      case ACTION_TYPES.UPDATE_CONTACT:
        props.setTriggerActionValue({
          data: {
            ...base,
            action_id: selected_action_id,
            defined_filter:
              updatedState.selected_contact_update_define_filters?.value ??
              null,
            selected_data:
              updatedState.selected_contact_update_take_action?.value ?? null,
          },
          index: RowIndex,
        });
        break;

      default:
        break;
    }
  };

  const actionAddToCampaign = (opt) => {
    setState((s) => {
      const newState = { ...s, selected_campaign_to_take_action: opt };
      publishActionValueWithState(newState); // Pass the updated state
      return newState;
    });
  };
  const actionAddToSource = (opt) => {
    setState((s) => {
      const newState = { ...s, selected_source_to_take_action: opt };
      publishActionValueWithState(newState);
      return newState;
    });
  };
  const actionAddToTag = (opt) => {
    setState((s) => {
      const newState = { ...s, selected_tag_to_take_action: opt };
      publishActionValueWithState(newState);
      return newState;
    });
  };
  const actionAddToList = (opt) => {
    setState((s) => {
      const newState = { ...s, selected_list_to_take_action: opt };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const actionAddToCollaborator = (opt) => {
    setState((s) => {
      const newState = { ...s, selected_collaborator_to_take_action: opt };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const actionAddToPipeline = (opt) => {
    setState((s) => {
      const newState = {
        ...s,
        selected_pipeline_to_take_action: opt,
        selected_stage_to_take_action:
          s.selected_pipeline_to_take_action?.value !== opt?.value
            ? null
            : s.selected_stage_to_take_action,
      };
      publishActionValueWithState(newState);
      getDefaultOptionForStage(opt?.value);
      return newState;
    });
  };

  const actionAddToStage = (opt) => {
    setState((s) => {
      const newState = { ...s, selected_stage_to_take_action: opt };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const actionChangeContactUpdateFilter = (opt) => {
    setState((s) => {
      const newState = {
        ...s,
        selected_contact_update_define_filters: opt,
        selected_contact_update_take_action: null,
      };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const actionChangeContactUpdate = (opt) => {
    setState((s) => {
      const newState = { ...s, selected_contact_update_take_action: opt };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const getDefaultOptionForCampaign = () => {
    let allOptions = [];
    if (props.allCampaign.length > 0) {
      const filtered =
        isAgencyTypeInsurance &&
        props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
          ? props.allCampaign.filter(
              (c) => c.privacyLevel === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
            )
          : props.allCampaign;
      allOptions = filtered.map((c) => ({ value: c.id, label: c.title }));
    }
    setState((s) => ({ ...s, defaultCampaignOptions: allOptions }));
  };

  const getDefaultOptionForSource = () => {
    const allOptions = props.allSources.map((s) => ({
      value: s.id,
      label: s.source_title,
    }));
    setState((s) => ({ ...s, defaultSourceOptions: allOptions }));
  };

  const getDefaultOptionForTag = () => {
    let allOptions = [];
    if (props.allTag.length > 0) {
      const filtered =
        isAgencyTypeInsurance &&
        props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
          ? props.allTag.filter(
              (t) => t.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
            )
          : props.allTag;
      allOptions = filtered.map((t) => ({ value: t.id, label: t.name }));
    }
    setState((s) => ({ ...s, defaultTagOptions: allOptions }));
  };

  const getDefaultOptionForList = () => {
    let allOptions = [];
    if (props.allList.length > 0) {
      const filtered =
        isAgencyTypeInsurance &&
        props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
          ? props.allList.filter(
              (l) => l.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
            )
          : props.allList;
      allOptions = filtered.map((l) => ({ value: l.id, label: l.title }));
    }
    setState((s) => ({ ...s, defaultListOptions: allOptions }));
  };

  const getDefaultOptionForCollaborator = () => {
    const allOptions = props.allCollaborator
      .filter((c) => c.status === 1)
      .map((c) => ({ value: c.id, label: c.full_name }));
    setState((s) => ({ ...s, defaultCollaboratorOptions: allOptions }));
  };

  const getTemplateCollaboratorList = () => {
    getCollaboratorDropdownList()
      .then((res) => {
        if (res.data.data.length > 0) {
          const list = res.data.data.map((d) => ({
            value: d.id,
            label: d.full_name,
          }));
          setState((s) => ({ ...s, templateCollaboratorList: list }));
        }
      })
      .catch((err) => console.error(err));
  };

  const getDefaultOptionForPipeline = () => {
    let allOptions = [];
    if (props.allPipeline.length > 0) {
      const filtered =
        isAgencyTypeInsurance &&
        props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
          ? props.allPipeline.filter(
              (p) => p.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
            )
          : props.allPipeline;
      allOptions = filtered.map((p) => ({ value: p.id, label: p.title }));
    }
    setState((s) => ({ ...s, defaultPipelineOptions: allOptions }));
  };

  const getDefaultOptionForStage = (pipelineId) => {
    const opts = props.allStage
      .filter((s) => s.pipeline_id === pipelineId)
      .map((s) => ({ value: s.id, label: s.stage }));
    setState((s) => ({ ...s, defaultStageOptions: opts }));
  };

  const getCollaboratorList = () => {
    if (!props.allCollaborator.length) {
      return <MenuItem disabled>No collaborators available</MenuItem>;
    }
    return props.allCollaborator.map((c) => (
      <MenuItem value={c.id} key={c.id}>
        {c.full_name}
      </MenuItem>
    ));
  };

  const getIntegrationList = () =>
    props.allIntegrations.map((i, idx) => (
      <option value={i.app_integrations[0].id} key={idx}>
        {i.app.name}
      </option>
    ));

  const getEachAction = (allActionItem) => {
    const data = [];

    if (allActionItem.length > 0) {
      allActionItem.forEach((item, index) => {
        if (props.triggerItemId === TRIGGER_TYPES.SMS_ACCOUNT_SUSPENDED) {
          if (
            item.key_index === ACTION_TYPES.TWILIO_PAUSE_ALL_CAMPAIGN ||
            item.key_index === ACTION_TYPES.TWILIO_PAUSE_ALL_COMMUNICATION ||
            item.key_index === ACTION_TYPES.TWILIO_EMAIL_USER ||
            item.key_index === ACTION_TYPES.TWILIO_SMS_USER
          ) {
            data.push(
              <MenuItem
                className="dropdownhelper-menuitem-class color__trigger_select"
                onClick={() => changeValue(item.key_index, item)}
                key={index}
                value={item.key_index}
              >
                {item.name}
              </MenuItem>
            );
          }
        } else if (
          props.triggerItemId === TRIGGER_TYPES.TWILIO_MESSAGE_FILTER
        ) {
          if (
            item.key_index === ACTION_TYPES.TWILIO_EMAIL_USER ||
            item.key_index === ACTION_TYPES.TWILIO_SMS_USER ||
            item.key_index === ACTION_TYPES.TWILIO_PAUSE_SPECIFIC_CAMPAIGN
          ) {
            data.push(
              <MenuItem
                className="dropdownhelper-menuitem-class color__trigger_select"
                onClick={() => changeValue(item.key_index, item)}
                key={index}
                value={item.key_index}
              >
                {item.name}
              </MenuItem>
            );
          }
        } else if (
          props.triggerItemId === TRIGGER_TYPES.TWILIO_DAILY_MESSAGE_CAP
        ) {
          if (
            item.key_index === ACTION_TYPES.TWILIO_EMAIL_USER ||
            item.key_index === ACTION_TYPES.TWILIO_SMS_USER
          ) {
            data.push(
              <MenuItem
                className="dropdownhelper-menuitem-class color__trigger_select"
                onClick={() => changeValue(item.key_index, item)}
                key={index}
                value={item.key_index}
              >
                {item.name}
              </MenuItem>
            );
          }
        } else if (item.key_index === ACTION_TYPES.UPDATE_CONTACT) {
          if (props.triggerItemId === TRIGGER_TYPES.ADDED_TAG) {
            data.push(
              <MenuItem
                className="dropdownhelper-menuitem-class color__trigger_select"
                onClick={() => changeValue(item.key_index, item)}
                key={index}
                value={item.key_index}
              >
                {item.name}
              </MenuItem>
            );
          }
        } else {
          if (
            item.key_index !== ACTION_TYPES.TWILIO_PAUSE_ALL_CAMPAIGN &&
            item.key_index !== ACTION_TYPES.TWILIO_PAUSE_ALL_COMMUNICATION &&
            item.key_index !== ACTION_TYPES.TWILIO_EMAIL_USER &&
            item.key_index !== ACTION_TYPES.TWILIO_SMS_USER &&
            item.key_index !== ACTION_TYPES.TWILIO_PAUSE_SPECIFIC_CAMPAIGN
          ) {
            data.push(
              <MenuItem
                className="dropdownhelper-menuitem-class color__trigger_select"
                onClick={() => changeValue(item.key_index, item)}
                key={index}
                value={item.key_index}
              >
                {item.name}
              </MenuItem>
            );
          }
        }
      });
    }
    return data;
  };

  const show = () => setState((s) => ({ ...s, show: !s.show }));
  const hide = () => setState((s) => ({ ...s, show: false }));

  const handlePersonalize = (opt) => {
    const textarea = textEditorRef.current;
    if (!textarea) return;
    const { selectionStart: start, selectionEnd: end, value: txt } = textarea;
    const before = txt.slice(0, start);
    const after  = txt.slice(end);
    const newText = before + opt.value + after;

    textarea.value = newText;
    textarea.selectionStart = textarea.selectionEnd = start + opt.value.length;
    textarea.focus();

    // now sync React state and dispatch:
    setState(s => {
      const newState = { ...s, sms: newText };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const handleEmailPersonalize = (e) => {
    const start = state.textEditorRef.selectionStart;
    const end = state.textEditorRef.selectionEnd;
    const txt = state.textEditorRef.value;
    const before = txt.slice(0, start);
    const after = txt.slice(end);
    const tag = e.currentTarget.getAttribute("data-url");
    const newText = before + tag + after;
    state.textEditorRef.value = newText;
    state.textEditorRef.selectionStart = state.textEditorRef.selectionEnd =
      start + tag.length;
    state.textEditorRef.focus();
    const newState = { ...state, email_body: newText };
    publishActionValueWithState(newState);
  };

  const calculateSmsCount = () => {
    const len = state.sms.length;
    let count = 1;
    if (len > 160) {
      const over = len - 160;
      count = over > 150 ? Math.ceil(len / 150) : 2;
    }
    setState((s) => ({ ...s, mySmsCount: count }));
    publishActionValueWithState(state);
  };

  const changeSms = (e) => {
    const sms = e.target.value;
    const len = sms.length;

    // Calculate pages: 1 page for up to 160 chars, then 150-char pages:
    let count = 1;
    if (len > 160) {
      const over = len - 160;
      count = over > 150 ? Math.ceil(len / 150) : 2;
    }

    setState((s) => ({
      ...s,
      sms,
      mySmsCount: count
    }));
    
    // And if you need to immediately dispatch your action-value:
    publishActionValueWithState({
      ...state,
      sms,
      mySmsCount: count
    });
  };

  const setEmailBody = (value) => {
    setState((s) => {
      const newState = { ...s, email_body: value, textEditor: value };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setState((s) => {
      const newState = { ...s, [name]: value };
      publishActionValueWithState(newState); // Or use original publishActionValue
      return newState;
    });
  };

  const onChangeEmailSubject = (subject) => {
    setState(s => {
      const newState = { ...s, email_subject: subject };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const onChangeSMSType = (e) => {
    setState((s) => {
      const newState = { ...s, to_sms_type: e.target.value };
      publishActionValueWithState(newState);
      return newState;
    });
  };
  const onChangeEmailType = (e) => {
    setState((s) => {
      const newState = { ...s, to_email_type: e.target.value };
      publishActionValueWithState(newState);
      return newState;
    });
  };
  const onChangeDealCreateOrMove = (e) => {
    setState((s) => {
      const newState = { ...s, createOrMove: +e.target.value };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const onChangeDealDelete = (e) => {
    setState((s) => {
      const newState = { ...s, deleteType: +e.target.value };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const dataChange = (opt) => {
    setState((s) => {
      const newState = { ...s, email_subject: s.email_subject + opt.value };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const taskHandler = (val) => {
    setState((s) => {
      const newState = { ...s, task_id: val };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const timeHandler = (val) => {
    setState((s) => {
      const newState = { ...s, time: val };
      publishActionValueWithState(newState);
      return newState;
    });
  };
  const durationHandler = (val) => {
    setState((s) => {
      const newState = { ...s, duration: val };
      publishActionValueWithState(newState);
      return newState;
    });
  };
  const setTextEditor = (html) => {
    if (html !== state.textEditor) {
      setState((s) => {
        const newState = { ...s, email_body: html };
        publishActionValueWithState(newState);
        return newState;
      });
    }
  };
  const handleCheck = () => {}; // no-op

  const sendZapierWebhook = (e) => {
    e.preventDefault();
    fetch(
      "https://webhook-api.pypepro.io/v1/zapier/webhook?" +
        new URLSearchParams({
          url: state.zapier_webhook_url,
          user_id: Utils.getAccountData("userId"),
        }),
      { mode: "no-cors", method: "POST" }
    )
      .then(() => window.showNotification("SUCCESS", "Request Sent!"))
      .catch(() => window.showNotification("ERROR", "Error!"));
  };

  const sendTestWebHook = (e) => {
    e.preventDefault();
    if (!state.webhook_url) {
      return window.showNotification("ERROR", "Please insert a valid url");
    }
    sendWebhookTest("POST", "https://core-api.pypepro.io/v1/webhook/test", {
      webhoookURL: state.webhook_url,
    }).then((res) => {
      if (res.status === "SUCCESS") {
        window.showNotification("SUCCESS", "Request Sent!");
      } else {
        try {
          window.showNotification(
            "ERROR",
            JSON.parse(res.message).error.message
          );
        } catch {
          window.showNotification(
            "ERROR",
            "Something went wrong, please try again."
          );
        }
      }
    });
  };

  const handleVirtualNumber = (opt) => {
    setState((s) => {
      const newState = { ...s, fromNumber: opt };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const handleFromEmail = (opt) => {
    setState((s) => {
      const newState = { ...s, from_email: opt };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  const onOpenWebhookBuilderModal = (data) => {
    setState((s) => ({
      ...s,
      selectedSmartWebhook: data,
      openSmartWebhookBuilder: true,
    }));
  };

  const onCloseWebhookBuilderModal = () => {
    setState((s) => ({
      ...s,
      openSmartWebhookBuilder: false,
      selectedSmartWebhook: null,
      isSubmittingAddSmartWebhookForm: false,
    }));
  };
  const handleSubmitWebhookForm = (payload) => {
    setState((s) => {
      const updatedPayload = state.selectedSmartWebhook?.id
        ? { ...payload, id: state.selectedSmartWebhook.id }
        : payload;

      const newState = {
        ...s,
        smart_webhook_data: updatedPayload,
        openSmartWebhookBuilder: false,
      };
      publishActionValueWithState(newState);
      return newState;
    });
  };

  // days list
  const days = Array.from({ length: 366 }, (_, i) => (
    <MenuItem className="dropdownhelper-menuitem-class" key={i} value={i}>
      {i === 0 ? "Not defined" : i}
    </MenuItem>
  ));
  // virtual numbers
  const newVirtualNumber = [
    { id: 0, label: "User default number", value: "{{user_default_number}}" },
    ...props.allVirtualNumber,
  ];

  return (
    <div className="action__item trigger__item">
      {/* Header + delete button */}
      <div className="d-flex justify-content-between align-content-center">
        <h4 className="trigger__action_title">
          Which action should we perform?
        </h4>
        <Button
          disabled={!hasPermission}
          className="action__delete"
          onClick={(e) => props.remover(e, props.RowIndex)}
          data-index={props.RowIndex}
        >
          {iconList.redDeleteIcon}
        </Button>
      </div>

      {/* Action selector */}
      <FormControl className="customFormControl">
        <MaterialSelect
          value={state.selected_action_id}
          displayEmpty
          className="trigger__select coloredText"
          inputProps={{ "aria-label": "Without label" }}
          disabled={!hasPermission}
        >
          <MenuItem
            className="actionItemDefault"
            value={0}
            disabled
            style={{
              padding: "6px 16px",
              width: "100%",
              justifyContent: "start",
            }}
          >
            Select action item
          </MenuItem>
          {getEachAction(props.allActionItem)}
        </MaterialSelect>
      </FormControl>

      {/* ADD_TO_CAMPAIGN */}
      {[
        ACTION_TYPES.ADD_TO_CAMPAIGN,
        ACTION_TYPES.REMOVE_FROM_SINGLE_CAMPAIGN,
      ].includes(state.selected_action_id) && (
        <div>
          {Utils.getAccountData("isTemplateUser") ||
          Utils.getAccountData("standardPack") ? (
            <div className="action__item trigger__item">
              <InputLabel className="trigger__action_title mbSpace10 d-flex align-items-center">
                <div>
                  Select a Campaign <span className="red-text">*</span>
                </div>
              </InputLabel>
              <Creatable
                styles={customEmailPersonalizedStyle}
                isClearable={false}
                options={state.defaultCampaignOptions}
                value={state.selected_campaign_to_take_action}
                isMulti={false}
                onChange={actionAddToCampaign}
                isDisabled={!hasPermission}
              />
            </div>
          ) : (
            Utils.getAccountData("starterPack") && (
              <div className="row py-3 lead-flow-card">
                <p className="text-danger">
                  <b>Sorry!</b> To use this feature please upgrade your package.{" "}
                  <b>
                    <a href={PACKAGE_PAGE_URL}>Buy Now</a>
                  </b>
                </p>
              </div>
            )
          )}
        </div>
      )}

      {/* ADD_TAG / REMOVE_TAG */}
      {[ACTION_TYPES.ADD_TAG, ACTION_TYPES.REMOVE_TAG].includes(
        state.selected_action_id
      ) && (
        <div className="action__item trigger__item">
          <InputLabel className="trigger__action_title mbSpace10 d-flex align-items-center">
            <div>
              Select a Tag <span className="red-text">*</span>
            </div>
          </InputLabel>
          <Creatable
            styles={customEmailPersonalizedStyle}
            isClearable={false}
            options={state.defaultTagOptions}
            value={state.selected_tag_to_take_action}
            isMulti={false}
            onChange={actionAddToTag}
            isDisabled={!hasPermission}
          />
        </div>
      )}

      {/* ADD_LIST / REMOVE_LIST */}
      {[ACTION_TYPES.ADD_LIST, ACTION_TYPES.REMOVE_LIST].includes(
        state.selected_action_id
      ) && (
        <div className="action__item trigger__item">
          <InputLabel className="trigger__action_title mbSpace10 d-flex align-items-center">
            <div>
              Select a List <span className="red-text">*</span>
            </div>
          </InputLabel>
          <Creatable
            styles={customEmailPersonalizedStyle}
            isClearable={false}
            options={state.defaultListOptions}
            value={state.selected_list_to_take_action}
            isMulti={false}
            onChange={actionAddToList}
            isDisabled={!hasPermission}
          />
        </div>
      )}

      {/* ADD_COLLABORATOR / REMOVE_COLLABORATOR */}
      {[
        ACTION_TYPES.ADD_COLLABORATOR,
        ACTION_TYPES.REMOVE_COLLABORATOR,
      ].includes(state.selected_action_id) && (
        <div className="action__item trigger__item">
          <InputLabel className="trigger__action_title mbSpace10 d-flex align-items-center">
            <div>
              Select a Collaborator <span className="red-text">*</span>
            </div>
          </InputLabel>
          <Creatable
            styles={customEmailPersonalizedStyle}
            isClearable={false}
            options={state.templateCollaboratorList}
            value={state.selected_collaborator_to_take_action}
            isMulti={false}
            onChange={actionAddToCollaborator}
            isDisabled={!hasPermission}
          />
        </div>
      )}

      {/* CHANGE_STAGE */}
      {state.selected_action_id === ACTION_TYPES.CHANGE_STAGE && (
        <div>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="create_or_move"
              name="create_or_move"
              value={state.createOrMove}
              disabled={!hasPermission}
              onChange={onChangeDealCreateOrMove}
            >
              <BootstrapTooltip arrow title="Keep existing deals, create new">
                <FormControlLabel
                  value={0}
                  control={<Radio disabled={!hasPermission} />}
                  label="Create New"
                />
              </BootstrapTooltip>
              <BootstrapTooltip arrow title="Remove existing deals, create new">
                <FormControlLabel
                  value={1}
                  control={<Radio disabled={!hasPermission} />}
                  label="Move Existing"
                />
              </BootstrapTooltip>
            </RadioGroup>
          </FormControl>

          <InputLabel className="trigger__action_title mbSpace10">
            Deal Value
          </InputLabel>
          <TextField
            disabled={!hasPermission}
            name="deal_value"
            type="number"
            value={state.deal_value}
            onChange={onChangeHandle}
            placeholder="Deal value"
            className="input_field_with_border"
          />

          <InputLabel className="trigger__action_title mbSpace10 mt-3">
            Estimated Closing Day
          </InputLabel>
          <MaterialSelect
            name="deal_closing_day"
            className={`trigger__select coloredText`}
            value={state.deal_closing_day}
            onChange={onChangeHandle}
            disabled={!hasPermission}
          >
            {days}
          </MaterialSelect>

          <InputLabel className="trigger__action_title mbSpace10 mt-3">
            Select a Pipeline <span className="red-text">*</span>
          </InputLabel>
          <Creatable
            styles={customEmailPersonalizedStyle}
            isClearable={false}
            options={state.defaultPipelineOptions}
            value={state.selected_pipeline_to_take_action}
            onChange={actionAddToPipeline}
            isDisabled={!hasPermission}
          />

          <InputLabel className="trigger__action_title mbSpace10 mt-3">
            Select a Stage <span className="red-text">*</span>
          </InputLabel>
          <Creatable
            styles={customEmailPersonalizedStyle}
            isClearable={false}
            options={state.defaultStageOptions}
            value={state.selected_stage_to_take_action}
            onChange={actionAddToStage}
            isDisabled={!hasPermission}
          />
        </div>
      )}

      {/* REMOVE_DEAL */}
      {state.selected_action_id === ACTION_TYPES.REMOVE_DEAL && (
        <div>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="deal_delete_type"
              name="deal_delete_type"
              value={state.deleteType}
              onChange={onChangeDealDelete}
            >
              <BootstrapTooltip arrow title="Remove from stage">
                <FormControlLabel
                  value={1}
                  control={<Radio disabled={!hasPermission} />}
                  label="Remove From Stage"
                />
              </BootstrapTooltip>
              <BootstrapTooltip arrow title="Remove all deals">
                <FormControlLabel
                  value={2}
                  control={<Radio disabled={!hasPermission} />}
                  label="Remove All"
                />
              </BootstrapTooltip>
            </RadioGroup>
          </FormControl>

          {state.deleteType === 1 && (
            <>
              <InputLabel className="trigger__action_title mbSpace10">
                Select a Pipeline <span className="red-text">*</span>
              </InputLabel>

              <Creatable
                styles={customEmailPersonalizedStyle}
                isClearable={false}
                options={state.defaultPipelineOptions}
                value={state.selected_pipeline_to_take_action}
                isMulti={false}
                onChange={actionAddToPipeline}
                isDisabled={!hasPermission}
              />

              <InputLabel className="trigger__action_title mbSpace10">
                Select a Stage <span className="red-text">*</span>
              </InputLabel>
              <Creatable
                styles={customEmailPersonalizedStyle}
                isClearable={false}
                options={state.defaultStageOptions}
                value={state.selected_stage_to_take_action}
                onChange={actionAddToStage}
                isDisabled={!hasPermission}
              />
            </>
          )}
        </div>
      )}

      {/* SEND_SMS */}
      {state.selected_action_id === ACTION_TYPES.SEND_SMS &&
        (Utils.getAccountData("isTemplateUser") ||
        Utils.getAccountData("standardPack") ? (
          <>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="to_sms_type"
                name="to_sms_type"
                value={state.to_sms_type}
                onChange={onChangeSMSType}
              >
                <BootstrapTooltip arrow title="Send to contact">
                  <FormControlLabel
                    value={0}
                    control={<Radio disabled={!hasPermission} />}
                    label="Contact"
                  />
                </BootstrapTooltip>
                <BootstrapTooltip arrow title="Send to number">
                  <FormControlLabel
                    value={1}
                    control={<Radio disabled={!hasPermission} />}
                    label="Number"
                  />
                </BootstrapTooltip>
              </RadioGroup>
            </FormControl>

            {state.to_sms_type === 1 && (
              <>
                <InputLabel className="trigger__action_title mbSpace10 mt-3 d-flex align-items-center">
                  <div>
                    To Number <span className="red-text">*</span>
                  </div>
                </InputLabel>
                <TextField
                  disabled={!hasPermission}
                  name="to_sms"
                  value={state.to_sms}
                  onChange={onChangeHandle}
                  className="input_field_with_border"
                  placeholder="To Number"
                />
              </>
            )}
            <div className="lead-flow-card">
              <div className="col s12 mb-3">
                <InputLabel className="trigger__action_title mbSpace10">
                  From Number <span className="red-text">*</span>
                </InputLabel>
                <Select
                  styles={customEmailPersonalizedStyle}
                  options={newVirtualNumber}
                  value={state.fromNumber}
                  onChange={handleVirtualNumber}
                  isDisabled={!hasPermission}
                />
              </div>
            </div>

            <FormGroup className="mt20px">
              <InputLabel className="trigger__action_title mbSpace10 d-flex align-items-end justify-content-between">
                <div>
                  Message <span className="red-text">*</span>
                </div>
                {props.personalize && (
                  <Select
                    value={null}
                    styles={customMessagePersonalizedStyle}
                    options={props.personalize}
                    placeholder="Personalize"
                    onChange={handlePersonalize}
                    isDisabled={!hasPermission}
                  />
                )}
              </InputLabel>
              
              <TextField
                inputRef={textEditorRef}
                multiline
                placeholder="Add SMS here"
                value={state.sms}
                onChange={changeSms}
                disabled={!hasPermission}
                className="messageTextField"
              />
            </FormGroup>

            <div className="pb-2">
              <span>
                Total SMS: <b>{state.sms.length}</b> / <b>{state.mySmsCount}</b>
              </span>
              {state.sms.length > 500 && (
                <div className="text-danger">Maximum 500 chars</div>
              )}
            </div>
          </>
        ) : (
          <div className="row py-3 lead-flow-card">
            <p className="text-danger">
              <b>Sorry!</b> Upgrade package to use this feature.{" "}
              <b>
                <a href={PACKAGE_PAGE_URL}>Buy Now</a>
              </b>
            </p>
          </div>
        ))}

      {/* SEND_EMAIL */}
      {state.selected_action_id === ACTION_TYPES.SEND_EMAIL &&
        (Utils.getAccountData("isTemplateUser") ||
          Utils.getAccountData("standardPack") ||
          Utils.getAccountData("starterProPack")) && (
          <>
            <div className="lead-flow-card py-3">
              <div className="col s12">
                <FormControl component="fieldset">
                  <FormLabel
                    component="legend"
                    className="trigger__action_title"
                  >
                    Send To
                  </FormLabel>
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    disabled={!hasPermission}
                    value={state.to_email_type}
                    onChange={onChangeEmailType}
                  >
                    <BootstrapTooltip
                      arrow
                      title="It means it will send the mail to contact"
                      placement="right"
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio disabled={!hasPermission} />}
                        label="Contact"
                      />
                    </BootstrapTooltip>
                    <BootstrapTooltip
                      arrow
                      title="It means it will send the mail to specific email that you put bellow"
                      placement="right"
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio disabled={!hasPermission} />}
                        label="An Email"
                      />
                    </BootstrapTooltip>
                  </RadioGroup>
                </FormControl>
              </div>

              {state.to_email_type === 1 && (
                <div className="col s12">
                  <div className="form-group m-form__group">
                    <InputLabel className="trigger__action_title mbSpace10 d-flex align-items-center">
                      <div>
                        To Email <span className="red-text">*</span>
                      </div>
                    </InputLabel>

                    <TextField
                      disabled={!hasPermission}
                      name="to_email"
                      value={state.to_email}
                      onChange={onChangeHandle}
                      placeholder="To Email"
                      className="input_field_with_border"
                    />
                  </div>
                </div>
              )}

              <InputLabel className="trigger__action_title mt-3 mbSpace10">
                From <span className="red-text">*</span>
              </InputLabel>
              <Select
                styles={customEmailPersonalizedStyle}
                options={props.allEmail}
                value={state.from_email}
                onChange={handleFromEmail}
                isDisabled={
                  !hasPermission ||
                  (props.agency.email_provider !== 0 &&
                    props.profile.email_provider === 1)
                }
              />
              <div className="email-form">
                <div className="email-form-field">
                  <div className="d-flex row mt-3">
                    <div className="field col s6">
                      <TextField
                        disabled={!hasPermission}
                        name="email_subject"
                        value={state.email_subject}
                        onChange={onChangeHandle}
                        className="input_field_with_border"
                        placeholder="Enter mail subject"
                      />
                    </div>

                    <div className="select col s6">
                      {props.personalize && (
                        <Select
                          styles={customPersonalizedStyle}
                          options={props.personalize}
                          placeholder="Personalize"
                          onChange={dataChange}
                          isDisabled={!hasPermission}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group m-form__group">
                <InputLabel className="trigger__action_title mbSpace10 d-flex align-items-center">
                  <div>
                    Message <span className="red-text">*</span>
                  </div>
                </InputLabel>
                {/*<textarea ref={ref => this.myTextInput = ref} onChange={this.onChangeHandle} name="email_body" cols="30" rows="5"
                                            className="form-control" placeholder="Add message here"
                                            value={this.state.email_body}/>*/}

                <TextEditor 
                  templates={props.email_templates}
                  customFields = {props.personalize}
                  action={ setTextEditor}
                  userSignature={props.profile.show_signature == 1 ? props.profile.signature : ''}
                  appointmentUrl={props.profile.show_appointment_url == 1 ? props.profile.appointment_url : ''}
                  handleCheck={(checkValue) => handleCheck(checkValue)}
                  updateComponent={state.email_body}
                  editSettings={props.actionValue ? true : false}
                  isShowSaveTemplate ={true}
                  isShowSaveTemplateOption={false}
                  fromNewTrigger={true}
                  subjectAction={onChangeEmailSubject}
                />
              </div>

              {Utils.getAccountData("starterPack") && (
                <div className="row py-3 lead-flow-card">
                  <p className="text-danger">
                    <b>Sorry!</b> Upgrade to starter-pro or standard.{" "}
                    <b>
                      <a href={PACKAGE_PAGE_URL}>Buy Now</a>
                    </b>
                  </p>
                </div>
              )}
            </div>
          </>
        )}

      {/* ADD_NOTE */}
      {state.selected_action_id === ACTION_TYPES.ADD_NOTE && (
        <div className="email__actions actions__append">
          <FormGroup className="mt20px">
            <InputLabel className="trigger__action_title mbSpace10">
              Note <span className="red-text">*</span>
            </InputLabel>
            <TextField
              name="note"
              multiline
              placeholder="Add note here"
              className="messageTextField"
              value={state.note}
              onChange={onChangeHandle}
              disabled={!hasPermission}
            />
          </FormGroup>
        </div>
      )}

      {/* WEBHOOK_URL */}
      {state.selected_action_id === ACTION_TYPES.WEBHOOK_URL && (
        <div className="action__item trigger__item">
          <InputLabel className="trigger__action_title mbSpace10">
            Webhook URL <span className="red-text">*</span>
          </InputLabel>
          <BootstrapTooltip
            arrow
            placement="top-start"
            title={
              <>
                <Typography color="inherit">Examples:</Typography>
                <p>https://example.com</p>
                <p>https://example.com/webhook</p>
              </>
            }
          >
            <TextField
              disabled={!hasPermission}
              name="webhook_url"
              value={state.webhook_url}
              onChange={onChangeHandle}
              placeholder="Add webhook link here"
              className="input_field_with_border"
            />
          </BootstrapTooltip>
          <div>
            <span className="m-form__help">
              Json data will be send. Sample given bellow
            </span>
            <br />
            {Utils.getAccountData("userId") == 1 ? (
              <code>
                [<br />
                &emsp;{"{"}
                <br />
                &emsp;&emsp;first_name: "John",
                <br />
                &emsp;&emsp;last_name: "Doe",
                <br />
                &emsp;&emsp;email: "example@example.com",
                <br />
                &emsp;&emsp;phone: "2202215656",
                <br />
                &emsp;&emsp;address: "23 SRS Colony, New York",
                <br />
                &emsp;&emsp;city: "New Baily",
                <br />
                &emsp;&emsp;state: "New York",
                <br />
                &emsp;&emsp;zip: 23233,
                <br />
                &emsp;&emsp;deal_value: 200000,
                <br />
                &emsp;&emsp;custom_field_1: value1,
                <br />
                &emsp;&emsp;custom_field_2: value2,
                <br />
                &emsp;&emsp;......
                <br />
                &emsp;{"}"}
                <br />
                ]<br />
              </code>
            ) : (
              <code>
                [<br />
                &emsp;{"{"}
                <br />
                &emsp;&emsp;first_name: "John",
                <br />
                &emsp;&emsp;last_name: "Doe",
                <br />
                &emsp;&emsp;email: "example@example.com",
                <br />
                &emsp;&emsp;phone: "2202215656",
                <br />
                &emsp;&emsp;address: "23 SRS Colony, New York",
                <br />
                &emsp;&emsp;city: "New Baily",
                <br />
                &emsp;&emsp;state: "New York",
                <br />
                &emsp;&emsp;zip: 23233,
                <br />
                &emsp;&emsp;deal_value: 200000
                <br />
                &emsp;{"}"}
                <br />
                ]<br />
              </code>
            )}

            <a
              href="#!"
              onClick={(e) =>
                hasPermission ? sendTestWebHook(e) : e.preventDefault()
              }
              className="btn btn-primary float-right m--font-primary m-form__help mt-3"
            >
              Send Sample Test
            </a>
          </div>
        </div>
      )}

      {/* SMART_WEBHOOK */}
      {state.selected_action_id === ACTION_TYPES.SMART_WEBHOOK && (
        <div className="action__item trigger__item">
          {state.smart_webhook_data ? (
            <div className="webhook-card">
              <h6
                title={state.smart_webhook_data.title}
                className="truncate-fix"
              >
                {state.smart_webhook_data.title}
              </h6>
              <p title={state.smart_webhook_data.url} className="truncate-fix">
                {state.smart_webhook_data.url}
              </p>
              <span
                onClick={() =>
                  hasPermission &&
                  onOpenWebhookBuilderModal(state.smart_webhook_data)
                }
                className="webhook-card-edit"
              >
                {iconList.editIcon}
              </span>
            </div>
          ) : (
            <button
              onClick={() => hasPermission && onOpenWebhookBuilderModal()}
              className="create-button-oip"
            >
              {iconList.bluePlusIcon} Create Smart Webhook
            </button>
          )}

          {state.openSmartWebhookBuilder && (
            <SmartWebhookDrawer
              key={state.selectedSmartWebhook?.id ?? "new"}
              data={state.selectedSmartWebhook}
              open={true}
              onClose={onCloseWebhookBuilderModal}
              onSubmit={handleSubmitWebhookForm}
            />
          )}
        </div>
      )}

      {/* ZAPIER_WEBHOOK */}
      {state.selected_action_id === ACTION_TYPES.ZAPIER_WEBHOOK && (
        <div className="action__item trigger__item">
          <InputLabel className="trigger__action_title mbSpace10">
            Webhook URL <span className="red-text">*</span>
          </InputLabel>
          <BootstrapTooltip
            arrow
            placement="top-start"
            title={
              <>
                <Typography color="inherit">Examples:</Typography>
                <p>https://example.com</p>
                <p>https://example.com/webhook</p>
              </>
            }
          >
            <TextField
              disabled={!hasPermission}
              name="zapier_webhook_url"
              value={state.zapier_webhook_url}
              onChange={onChangeHandle}
              placeholder="Add webhook link here"
              className="input_field_with_border"
            />
          </BootstrapTooltip>
          <div>
            <span className="m-form__help">
              Json data will be send. Sample given bellow
            </span>
            <br />
            {Utils.getAccountData("userId") == 1 ? (
              <code>
                [<br />
                &emsp;{"{"}
                <br />
                &emsp;&emsp;first_name: "John",
                <br />
                &emsp;&emsp;last_name: "Doe",
                <br />
                &emsp;&emsp;email: "example@example.com",
                <br />
                &emsp;&emsp;phone: "2202215656",
                <br />
                &emsp;&emsp;address: "23 SRS Colony, New York",
                <br />
                &emsp;&emsp;city: "New Baily",
                <br />
                &emsp;&emsp;state: "New York",
                <br />
                &emsp;&emsp;zip: 23233,
                <br />
                &emsp;&emsp;deal_value: 200000,
                <br />
                &emsp;&emsp;custom_field_1: value1,
                <br />
                &emsp;&emsp;custom_field_2: value2,
                <br />
                &emsp;&emsp;......
                <br />
                &emsp;{"}"}
                <br />
                ]<br />
              </code>
            ) : (
              <code>
                [<br />
                &emsp;{"{"}
                <br />
                &emsp;&emsp;first_name: "John",
                <br />
                &emsp;&emsp;last_name: "Doe",
                <br />
                &emsp;&emsp;email: "example@example.com",
                <br />
                &emsp;&emsp;phone: "2202215656",
                <br />
                &emsp;&emsp;address: "23 SRS Colony, New York",
                <br />
                &emsp;&emsp;city: "New Baily",
                <br />
                &emsp;&emsp;state: "New York",
                <br />
                &emsp;&emsp;zip: 23233,
                <br />
                &emsp;&emsp;deal_value: 200000
                <br />
                &emsp;{"}"}
                <br />
                ]<br />
              </code>
            )}

            <a
              href="#!"
              onClick={(e) =>
                hasPermission ? sendZapierWebhook(e) : e.preventDefault()
              }
              className="btn btn-primary float-right m--font-primary m-form__help mt-3"
            >
              Send Sample Test
            </a>
          </div>
        </div>
      )}

      {/* ADD_TASK */}
      {state.selected_action_id === ACTION_TYPES.ADD_TASK && (
        <div>
          <SelectTask
            isDisabled={!hasPermission}
            taskHandler={taskHandler}
            task_id={state.task_id}
            taskTitle=""
          />
          <InputLabel className="trigger__action_title mbSpace10">
            Title <span className="red-text">*</span>
          </InputLabel>
          <TextField
            name="title"
            disabled={!hasPermission}
            value={state.title}
            onChange={onChangeHandle}
            placeholder="Enter Title"
            className="input_field_with_border"
          />
          <FormGroup className="mt20px">
            <InputLabel className="trigger__action_title mbSpace10">
              Description
            </InputLabel>
            <TextField
              name="task_description"
              multiline
              placeholder="Add description here"
              value={state.task_description}
              onChange={onChangeHandle}
              disabled={!hasPermission}
              className="messageTextField"
            />
          </FormGroup>

          <div className="form-group m-form__group mb-4">
            <InputLabel className="trigger__action_title mbSpace10">
              Assign To
            </InputLabel>
            <MaterialSelect
              displayEmpty
              name="assign_to"
              value={Number.isNaN(state.assign_to) ? null : state.assign_to}
              className={`trigger__select coloredText assignTo`}
              onChange={onChangeHandle}
              disabled={!hasPermission}
              MenuProps={{
                MenuListProps: {
                  style: {
                    padding: 16,
                    display: "flex",
                    flexDirection: "column",
                  },
                },
              }}
            >
              <MenuItem value={null}>Select an user</MenuItem>
              {getCollaboratorList()}
            </MaterialSelect>
          </div>

          <InputLabel className="trigger__action_title mbSpace10">
            Day
          </InputLabel>
          <MaterialSelect
            displayEmpty
            name="day"
            className={`trigger__select coloredText`}
            value={state.day}
            onChange={onChangeHandle}
            disabled={!hasPermission}
          >
            {days}
          </MaterialSelect>

          <InputLabel className="trigger__action_title mbSpace10 mt-4">
            Time
          </InputLabel>
          <GetTimeOptions
            isDisabled={!hasPermission}
            value={state.time}
            timeHandler={timeHandler}
          />
          <InputLabel className="trigger__action_title mbSpace10 mt-4">
            Duration (hh:mm)
          </InputLabel>
          <GetDurationOptions
            isDisabled={!hasPermission}
            value={state.duration}
            durationHandler={durationHandler}
          />
        </div>
      )}

      {/* THIRD_PARTY_INTEGRATION */}
      {state.selected_action_id === ACTION_TYPES.THIRD_PARTY_INTEGRATION && (
        <div className="mt-2">
          <InputLabel className="trigger__action_title mbSpace10">
            Select the platform <span className="red-text">*</span>
          </InputLabel>
          <MaterialSelect
            displayEmpty
            name="integration_id"
            value={
              Number.isNaN(state.integration_id) ? null : state.integration_id
            }
            onChange={onChangeHandle}
            disabled={!hasPermission}
            className={`trigger__select coloredText`}
          >
            <MenuItem value={null}>Select a platform</MenuItem>
            {getIntegrationList()}
          </MaterialSelect>
        </div>
      )}

      {/* ADD_SOURCE */}
      {state.selected_action_id === ACTION_TYPES.ADD_SOURCE &&
        (Utils.getAccountData("isTemplateUser") ||
        Utils.getAccountData("standardPack") ? (
          <div className="mt-3">
            <Creatable
              styles={customEmailPersonalizedStyle}
              isClearable={false}
              options={state.defaultSourceOptions}
              value={state.selected_source_to_take_action}
              onChange={actionAddToSource}
              isDisabled={!hasPermission}
            />
          </div>
        ) : (
          Utils.getAccountData("starterPack") && (
            <div className="row py-3 lead-flow-card">
              <p className="text-danger">
                <b>Sorry!</b> Upgrade to use this feature.{" "}
                <b>
                  <a href={PACKAGE_PAGE_URL}>Buy Now</a>
                </b>
              </p>
            </div>
          )
        ))}

      {/* TWILIO_SMS_USER */}
      {state.selected_action_id === ACTION_TYPES.TWILIO_SMS_USER && (
        <div className="action__item trigger__item">
          <TextField
            name="twilio_sms_send_user"
            value={state.twilio_sms_send_user}
            onChange={onChangeHandle}
            placeholder="Add users contacts by comma separator"
          />
          <FormGroup className="mt20px">
            <InputLabel className="trigger__action_title mbSpace10 d-flex align-items-end justify-content-between">
              <div>
                Message <span className="red-text">*</span>
              </div>
              {props.personalize && (
                <Select
                  styles={customMessagePersonalizedStyle}
                  options={props.personalize}
                  placeholder="Personalize"
                  onChange={handlePersonalize}
                />
              )}
            </InputLabel>
              <TextField
                multiline
                placeholder="Add SMS here"
                value={state.sms}
                onChange={changeSms}
                disabled={!hasPermission}
                className="messageTextField"
              />
          </FormGroup>
        </div>
      )}

      {/* TWILIO_EMAIL_USER */}
      {state.selected_action_id === ACTION_TYPES.TWILIO_EMAIL_USER && (
        <div className="action__item trigger__item">
          <TextField
            name="twilio_email_send_user"
            value={state.twilio_email_send_user}
            onChange={onChangeHandle}
            placeholder="Add users email by comma separator"
          />
          <InputLabel className="trigger__action_title mbSpace10">
            Subject <span className="red-text">*</span>
          </InputLabel>
          <div className="d-flex">
            <TextField
              name="email_subject"
              value={state.email_subject}
              onChange={onChangeHandle}
              placeholder="Enter mail subject"
            />
            {props.personalize && (
              <Select
                styles={customPersonalizedStyle}
                options={props.personalize}
                placeholder="Personalize"
                onChange={dataChange}
              />
            )}
          </div>
          <TextEditor
            templates={props.email_templates}
            customFields={props.personalize}
            action={setTextEditor}
            userSignature={
              props.profile.show_signature === 1 ? props.profile.signature : ""
            }
            appointmentUrl={
              props.profile.show_appointment_url === 1
                ? props.profile.appointment_url
                : ""
            }
            handleCheck={handleCheck}
            updateComponent={state.email_body}
            editSettings={!!props.actionValue}
            isShowSaveTemplate
            isShowSaveTemplateOption={false}
            fromNewTrigger
            subjectAction={onChangeEmailSubject}
          />
        </div>
      )}

      {/* UPDATE_CONTACT */}
      {state.selected_action_id === ACTION_TYPES.UPDATE_CONTACT && (
        <div className="action__item trigger__item justify-content-between flex-row">
          <div style={{ width: "45%" }}>
            <InputLabel className="trigger__action_title mbSpace10">
              Define Filter <span className="red-text">*</span>
            </InputLabel>
            <Select
              styles={customEmailPersonalizedStyle}
              options={ACTION_CONTACT_UPDATE_DEFINED_FILTER}
              value={state.selected_contact_update_define_filters}
              onChange={actionChangeContactUpdateFilter}
            />
          </div>
          {state.selected_contact_update_define_filters?.value === "phone" && (
            <div style={{ width: "45%" }}>
              <InputLabel className="trigger__action_title mbSpace10">
                Select an option <span className="red-text">*</span>
              </InputLabel>
              <Select
                styles={customEmailPersonalizedStyle}
                options={ACTION_CONTACT_UPDATE_FILTER_OPTIONS}
                value={state.selected_contact_update_take_action}
                onChange={actionChangeContactUpdate}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const EachAction = connect(mapStateToProps, mapDispatchToProps)(SingleAction);

export default EachAction;
